import { render, staticRenderFns } from "./MessageFileUpload.vue?vue&type=template&id=68296322&scoped=true"
import script from "./MessageFileUpload.vue?vue&type=script&lang=js"
export * from "./MessageFileUpload.vue?vue&type=script&lang=js"
import style0 from "./MessageFileUpload.vue?vue&type=style&index=0&id=68296322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68296322",
  null
  
)

export default component.exports